<template>
  <div class="details-container">
    <div class="details-header">
      <h6 class="details-title">
        <i class="fa fa-list"></i>
        Список виробів
      </h6>
      <button class="btn btn-primary" @click="add">
        <i class="fa fa-plus"></i>
        Додати
      </button>
    </div>
    <div class="details-list" v-if="detailsName && detailsName.length > 0">
      <div v-for="(detail, index) in detailsName" :key="index" class="detail-item">
        <div class="detail-number">{{ index + 1 }}</div>

        <div class="detail-content">
          <div class="detail-input">
            <input :id="'dt_' + index" placeholder="Назва виробу" v-model="detail.name" type="text" class="form-input">
          </div>
        </div>

        <div class="detail-actions" @click.stop>
          <button class="btn btn-sm btn-outline-danger" @click="remove(index)" v-b-tooltip.hover.top="'Видалити'">
            <i class="far fa-trash-alt"></i>
          </button>
        </div>
      </div>
    </div>

    <div v-else class="details-empty">
      <small class="text-muted">
        <i class="fa fa-info-circle"></i>
        Список виробів порожній
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailsNameTable",
  props: ['detailsName'],
  methods: {
    add() {
      this.detailsName.push({ name: '' })
    },
    remove(i) {
      this.detailsName.splice(i, 1);
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
/* Стили в том же стиле что и MaterialsTable.vue */
.details-container {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 10px;
  width: 100%;
}

.details-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #dee2e6;
}

.details-title {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 6px;
}

.details-title i {
  color: #2c5aa0;
  font-size: 0.8rem;
}

.details-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  background: white;
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
  gap: 8px;
  min-height: 40px;
}

.detail-item:hover {
  background: #f8f9fa;
  border-color: #19469e;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.detail-number {
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  min-width: 20px;
  text-align: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.detail-content {
  flex: 1;
  min-width: 0;
}

.detail-input {
  width: 100%;
}

.form-input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  background: white;
  font-weight: 500;
  line-height: 1.3;
}

.form-input:focus {
  outline: none;
  border-color: #2c5aa0;
  box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.1);
}

.form-input::placeholder {
  color: #6c757d;
  font-weight: normal;
}

.detail-actions {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
}

.details-empty {
  text-align: center;
  padding: 12px;
  color: #6c757d;
}

.details-empty i {
  margin-right: 6px;
}

/* Bootstrap button overrides - точно как в MaterialsTable */
.btn-sm {
  padding: 3px 6px;
  font-size: 0.7rem;
}

.btn-primary {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
}

.btn-primary:hover {
  background-color: #1e4a8a;
  border-color: #1e4a8a;
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}
</style>